import { joinClasses } from 'utils/componentStyles/style.utils';

const WeatherMapWidgetEmptyState = ({ ariaLabel, title, message, className }) => (
  <section
    aria-label={ariaLabel}
    className={joinClasses(
      'd-flex h-100 min-h-0 w-100 align-items-center justify-content-center overflow-hidden p-3',
      className,
    )}
  >
    <div className="w-100 rounded-3 border p-3 shadow-sm">
      <h2 className="mb-2 fs-5 fw-bold">{title}</h2>
      <p className="mb-0 text-secondary" role="status">
        {message}
      </p>
    </div>
  </section>
);

export default WeatherMapWidgetEmptyState;
